










import Vue from 'vue';
import { PortalTarget } from 'portal-vue';

import AppGlobalHeader from '@/components/AppGlobalHeader.vue';

export default Vue.extend({
  components: {
    PortalTarget,
    AppGlobalHeader,
  },
});
